import styled, { css } from "styled-components";
import { Github } from "@styled-icons/boxicons-logos/Github";
import { Instagram } from "@styled-icons/boxicons-logos/Instagram";
import { Linkedin } from "@styled-icons/bootstrap/Linkedin";
import Image from "../../assets/imgs/apple.jpg";

export const Container = styled.div`
  display: flex;
  width: 100%; ;
`;
const Main = css`
  padding: 0 100px;
  position: relative;
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  background: url(${Image});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  @media (max-width: 1049px) {
    padding: 0 20px;
  }
`;
const Content = css`
  max-width: 800px;
  color: #ffffff;
  font-size: 36px;
  font-weight: 500;
  animation: meals-appear 1s ease-out forwards;
  @keyframes meals-appear {
    from {
      opacity: 0;
      transform: translateY(8rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const Animated = css`
  height: 70px;
  overflow: hidden;
  position: relative;
  color: crimson;
  font-size: 52px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 1px;
  user-select: none;
`;
export const Wrapper = styled.div`
  ${({ main }) => main && Main};
  ${({ content }) => content && Content}
  ${({ animated }) => animated && Animated};
`;
const User = css`
  font-size: 60px;
  font-weight: 600;
  @media (max-width: 1049px) {
    font-size: 35px;
  }
`;
const TitleMedia = css`
  @media (max-width: 1049px) {
    font-size: 35px;
  }
`;
export const Title = styled.div`
  ${({ user }) => user && User};
  ${({ title }) => title && TitleMedia}

  :nth-child(1) {
    animation: ${({ title }) => title && "text-move 10s infinite"};
  }
  @keyframes text-move {
    0% {
      margin-top: 0;
    }
    25% {
      margin-top: -75px;
    }
    50% {
      margin-top: -140px;
    }
    75% {
      margin-top: -70px;
    }
    100% {
      margin-top: 0px;
    }
  }
`;
const Btn = css`
  color: #fff;
  background-color: crimson;
  font-size: 17px;
  font-weight: 600;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 50px;
  user-select: none;
  cursor: pointer;
  letter-spacing: 1px;
  margin: 30px 0;
  :hover {
    color: #000;
    background-color: #fff;
    transition: 0.2s ease-in-out;
  }
  :active {
    transform: scale(1.3);
  }
`;
export const NavbarLink = styled.a`
  ${({ btn }) => btn && Btn}
`;

export const Icon = styled.div``;

Icon.Github = styled(Github)`
  width: 30px;
  height: 30px;
  cursor: pointer;
  opacity: 0.7;
  :hover {
    opacity: 1;
  }
`;
Icon.Instagram = styled(Instagram)`
  width: 30px;
  height: 30px;
  cursor: pointer;

  opacity: 0.7;
  :hover {
    opacity: 1;
  }
`;
Icon.Linkedin = styled(Linkedin)`
  width: 27px;
  height: 27px;
  cursor: pointer;
  opacity: 0.7;
  :hover {
    opacity: 1;
  }
`;
export const IconWrapper = styled.a`
  width: ${({ main }) => main && "140px"};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
`;
